import { useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useAuthStore } from '@/store/auth'

interface OnboardingGuardProps {
  children: React.ReactNode
}

export function OnboardingGuard({ children }: OnboardingGuardProps) {
  const navigate = useNavigate()
  const location = useLocation()
  const { user, hasCompletedOnboarding, hasColdStartCompleted, setOnboardingComplete, setColdStartComplete } = useAuthStore()

  useEffect(() => {
    const path = location.pathname

    // Skip guard when already on guarded paths
    if (path === '/onboarding' || path === '/style-discovery') {
      return
    }

    // Step 1: Must complete onboarding first
    if (!hasCompletedOnboarding) {
      const isComplete = user?.hasCompletedOnboarding === true
      if (isComplete) {
        setOnboardingComplete(true)
      } else {
        navigate('/onboarding', { replace: true })
        return
      }
    }

    // Step 2: Must complete style discovery (cold start)
    if (!hasColdStartCompleted) {
      const isComplete = user?.cold_start_completed === true
      if (isComplete) {
        setColdStartComplete(true)
      } else {
        navigate('/style-discovery', { replace: true })
      }
    }
  }, [location.pathname, hasCompletedOnboarding, hasColdStartCompleted, user, navigate, setOnboardingComplete, setColdStartComplete])

  return <>{children}</>
}
